export var OPERATION_TYPENAME;
(function (OPERATION_TYPENAME) {
    OPERATION_TYPENAME["UPDATE"] = "HospitalChangeRequestUpdateOperation";
    OPERATION_TYPENAME["CREATE"] = "HospitalChangeRequestCreateOperation";
})(OPERATION_TYPENAME || (OPERATION_TYPENAME = {}));
